import React, { useState, useEffect } from "react";
import {
    callRatesApi,
    getIBRRate,
    getMargin,
    updateFee,
    updateMargin,
} from "../../services/margin";
import { merge_object_arrays, currencySequence } from "../../utils";
import Toast from "../../components/ui/Toast";
import { isUndefined } from "underscore";
import Skeleton from "react-loading-skeleton";

export const sanitizeNumberInput = (value: string) =>
    value.replace(/[^0-9.]/g, "");


const MarginNew = () => {
    const [purposeCode, setPurposeCode] = useState({
        label: "AD II",
        value: "marginValue"
    });
    const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

    const [customers, setCustomers] = useState<any[]>([]);
    const [marginData, setMarginData] = useState();
    const [fxRates, setFxRates] = useState();
    const [fee, setFee] = useState();
    const [feeGift, setFeeGift] = useState();
    const [feeMaintenance, setFeeMaintenance] = useState();
    const [bankFee, setBankFee] = useState();
    const [bankFeeGift, setBankFeeGift] = useState();
    const [bankFeeMaintenance, setBankFeeMaintenance] = useState();
    const [nostro, setNostro] = useState();
    const [nostroGift, setNostroGift] = useState();
    const [nostroMaintenance, setNostroMaintenance] = useState();
    const [purposeCodeSend, setPurposeCodeSend] = useState("AD II");
    const [errMessage, setErrMessage] = useState("");

    const [bankFees, setBankFees] = useState();
    const [vendorFee, setVendorFee] = useState<any>();
    const [nostroCharge, setNostroCharge] = useState();

    const [editable, setEditable] = useState(false);
    const [newAdRate, setNewAdRate] = useState([]);
    const [editingCurrency, setEditingCurrency] = useState<string | null>(null);
    const [editedVendorMargin, setEditedVendorMargin] = useState<Record<string, Record<string, string>>>({});
    const [toastMessage, setToastMessage] = React.useState<any>();
    const [updatingMargin, setUpdatingMargin] = useState(false);
    const [tempVendorFee, setTempVendorFee] = useState<string>("");

    const didInit = React.useRef(false);

    const handleUpdateMargin = (row: any) => {
        const existingVendorMargin =
            purposeCode.label === "AD II"
                ? row.vendorMarginValue
                : purposeCode.label === "Gift"
                    ? row.vendorMarginValueGift
                    : row.vendorMarginValueMaintenance;

        const editedValueForRow = editedVendorMargin?.[row.currency]?.[purposeCode?.label];

        const finalMarginValue =
            editedValueForRow !== undefined &&
                Number(editedValueForRow) !== Number(existingVendorMargin)
                ? Number(editedValueForRow)
                : Number(existingVendorMargin);

        const payload = {
            currency: row.currency,
            margin_value: finalMarginValue,
            vendor_key: currentUser.vendor_key,
            purpose: purposeCodeSend,
        };
        setUpdatingMargin(true);
        updateMargin(payload).then((res) => {
            setToastMessage(res?.data);
            setUpdatingMargin(false);
            getMarginData();

        });
    };

    async function handleUpdateFee(tempVendorFee: string) {

        const feeData = {
            vendorBankFee: bankFees ?? 0,
            vendorConvenienceFee: Number(tempVendorFee) || 0,
            vendorNostroCharge: nostroCharge ?? 0,
            vendor_key: currentUser.vendor_key,
            purpose: purposeCodeSend,
        };

        try {
            const res = await updateFee(feeData);

            // ✅ commit only AFTER successful API call
            setVendorFee(tempVendorFee);
            setEditable(false);
            setToastMessage(res?.data);
            getMarginData();
        } catch (err: any) {
            setErrMessage(err?.response?.data?.error?.type);
            setToastMessage(err?.response?.data);
        }
    }

    useEffect(() => {
        if (purposeCode && purposeCode.value === "marginValue") {
            setPurposeCodeSend("other");
        } else if (purposeCode && purposeCode.label === "Gift") {
            setPurposeCodeSend("gift");
        } else if (purposeCode && purposeCode.label === "Maintenance") {
            setPurposeCodeSend("maintenance");
        }
    }, [purposeCode]);

    React.useEffect(() => {
        if (bankFee && purposeCode.label === "AD II") {
            setBankFees(bankFee);
        } else if (bankFeeGift && purposeCode.label === "Gift") {
            setBankFees(bankFeeGift);
        } else if (bankFeeMaintenance && purposeCode.label === "Maintenance") {
            setBankFees(bankFeeMaintenance);
        }

        if (fee && purposeCode.label === "AD II") {
            setVendorFee(fee);
        }
        else{
            setVendorFee(fee);
        }
        //  else if (feeGift && purposeCode.label === "Gift") {
        //     setVendorFee(feeGift);
        // } else if (feeMaintenance && purposeCode.label === "Maintenance") {
        //     setVendorFee(feeMaintenance);
        // }

        if (nostro && purposeCode.label === "AD II") {
            setNostroCharge(nostro);
        } else if (nostroGift && purposeCode.label === "Gift") {
            setNostroCharge(nostroGift);
        } else if (nostroMaintenance && purposeCode.label === "Maintenance") {
            setNostroCharge(nostroMaintenance);
        }
    }, [fee, bankFee, nostro, purposeCode]);

    const getMarginData = () => {
        getMargin().then((res: any) => {
            setToastMessage(res?.data);
            const data = res.data.Margin_List;
            const fees = tempVendorFee != "" ? tempVendorFee : res.data.convenience_fee;
            const feesGift = res.data.convenience_fee_gift;
            const feesMaintenance = res.data.convenience_fee_maintenance;
            const bfees = res.data.bank_fee;
            const bfeesGift = res.data.bank_fee_gift;
            const bfeesMaintenance = res.data.bank_fee_maintenance;
            const nostroCharge = res.data.nostro_charge;
            const nostroChargeGift = res.data.nostro_charge_gift;
            const nostroChargeMaintenance = res.data.nostro_charge_maintenance;

            setMarginData(data);
            setFee(fees);
            setFeeGift(feesGift);
            setFeeMaintenance(feesMaintenance);
            setBankFee(bfees);
            setBankFeeGift(bfeesGift);
            setBankFeeMaintenance(bfeesMaintenance);
            setNostro(nostroCharge);
            setNostroGift(nostroChargeGift);
            setNostroMaintenance(nostroChargeMaintenance);
        });
    };

    const getIBRRateData = () => {
        getIBRRate(currentUser).then((res: any) => {
            const rates = res.data.rate;
            setToastMessage(res?.data);
            const fxRates: any = Object.keys(rates).map((item) => {
                return {
                    [item]: rates[item],
                    currency: `${item}`,
                    rate: rates[item],
                };
            });
            setFxRates(fxRates);
        });
    };

    React.useEffect(() => {
        if (marginData && fxRates && newAdRate) {
            const merged1 = merge_object_arrays(marginData, fxRates, "currency");

            const normalizedAdRate = newAdRate.map((item: any) => ({
                currency: item.currency,
                cardRate: item.cardRate,
                cardRateAd1: item.cardRateAd1
            }));

            const mergedFinal = merge_object_arrays(
                merged1,
                normalizedAdRate,
                "currency"
            );

            mergedFinal.sort(
                (a: any, b: any) =>
                    currencySequence.indexOf(a.currency) -
                    currencySequence.indexOf(b.currency)
            );

            setCustomers(mergedFinal);
        }
    }, [marginData, fxRates, newAdRate]);

    useEffect(() => {
        if (didInit.current) return;
        didInit.current = true;
        getMarginData();
        getIBRRateData();
        ratesApi();
    }, []);


    const ratesApi = async () => {
        try {
            const api = await callRatesApi();
            const response = await api?.data;
            if (response) {
                setToastMessage(response?.data);
                const rates = response?.cardRate;
                rates.sort(
                    (a: any, b: any) =>
                        currencySequence.indexOf(a.currency) - currencySequence.indexOf(b.currency),
                );
                setNewAdRate(rates);
            }
        } catch (error) {
            window.console.error("Error", error);
        }
    };

    const handleCloseToast = () => {
        setToastMessage(null);
    };

    const purposeOptions = [
        { label: "AD II", value: "marginValue" },
        { label: "Maintenance", value: "marginValueMaintanence" },
        { label: "Gift", value: "marginValueGift" }
    ];

    return (
        <div className="min-h-screen bg-background py-12 px-8">
            {toastMessage != null &&
                <Toast
                    message={toastMessage?.message?.toUpperCase()}
                    type={toastMessage?.success == true || toastMessage?.success == "true" ? "success" : "failure"}
                    onClose={handleCloseToast}
                />
            }
            <div className="max-w-[1440px] mx-auto">
                <h1 className="text-2xl font-semibold text-foreground">Currency Margin</h1>

                <div className="w-full h-[1px] bg-[#D6D6D6] my-4" />

                {/* Purpose Code Selector */}
                <div className="flex items-center gap-4 mb-5">
                    <span className="text-sm text-muted-foreground">Select purpose code</span>
                    <div className="flex bg-[#E6E6E6] rounded-lg p-1 h-[36px] items-center">
                        {purposeOptions.map((code, i) => (
                            <button
                                key={i}
                                onClick={() => { setPurposeCode(code); setEditable(false); setEditingCurrency(null); }}
                                className={`text-sm font-medium border transition-colors 
                                    ${purposeCode.label === code.label
                                        ? "bg-[#fff] text-primary-100 rounded-md shadow-md px-3 py-1"
                                        : "bg-card text-foreground border-border hover:bg-[#fff] hover:rounded-md py-1 px-4 "
                                    } ${code.label === purposeOptions[0].label ? "rounded-l-md" : ""} ${code === purposeOptions[purposeOptions.length - 1] ? "rounded-r-md" : ""
                                    } ${code.label !== purposeOptions[0].label ? "-ml-px" : ""}`}
                            >
                                {code.label}
                            </button>
                        ))}
                    </div>
                </div>

                {/* Fees Section */}
                {
                    purposeCodeSend == "other" ?
                        <div className="pt-4 mb-6 bg-[#f8f5f494] rounded-xl border border-[#EEEFF2] py-4 px-4">
                            <h2 className="text-base font-semibold text-foreground mb-[6px]">Fees and Charges</h2>

                            <div className="grid grid-cols-3 gap-8 border-t border-[#D0D0D0]  pt-4 px-4">
                                <div>
                                    <label className="text-xs text-label block mb-1 text-[#646464]">Bank Fees</label>
                                    <p className="text-xl font-medium text-foreground">500</p>
                                </div>
                                <div>
                                    <label className="text-xs text-label block mb-1 text-[#646464]">NOSTRO Fees</label>
                                    <p className="text-xl font-medium text-foreground">1500</p>
                                </div>
                                <div className="relative">
                                    <label className="text-xs text-label  block mb-1 text-[#646464]">Vendor Fees</label>
                                    <div className={`flex items-center border border-[#D0D0D0] rounded-md px-2 py-[6px]  ${editable ? "bg-[#fff]" : "bg-transparent"}`}>
                                        <input
                                            type="text"
                                            value={editable ? tempVendorFee : vendorFee}
                                            onChange={(e) => setTempVendorFee(sanitizeNumberInput(e.target.value))}
                                            className={`flex-1 text-lg font-medium text-foreground outline-none ${editable ? "bg-[#fff]" : "bg-transparent"}`}
                                            disabled={editable ? false : true}
                                        />
                                        {editable ?
                                            <div className="flex items-center gap-2">
                                                <button className="p-2 border-[0.752px] border-[#383e4724] rounded-[4px] opacity-90" onClick={() => {
                                                    setVendorFee(tempVendorFee);
                                                    handleUpdateFee(tempVendorFee);
                                                    setEditable(false);
                                                }}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" viewBox="0 0 14 10" fill="none">
                                                        <path d="M0.75 5.19444L4.44231 8.75L12.75 0.75" stroke="#092957" stroke-width="1.5" stroke-linecap="round" />
                                                    </svg>
                                                </button>

                                                <button className="p-2 border-[0.752px] border-[#383e4724] rounded-[4px] opacity-90" onClick={() => {
                                                    setTempVendorFee(vendorFee); // revert
                                                    setEditable(false);
                                                }}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                                                        <path d="M9.4242 0.000157177C9.27557 0.00366517 9.13438 0.0658704 9.03148 0.173176L4.99987 4.20479L0.96826 0.173176C0.915828 0.119131 0.853077 0.0761632 0.78373 0.0468202C0.714383 0.0174773 0.63985 0.00235652 0.56455 0.00235424C0.452592 0.00238046 0.343188 0.0358156 0.250343 0.0983802C0.157497 0.160945 0.0854337 0.249792 0.043376 0.353551C0.00131824 0.457309 -0.00882019 0.571257 0.0142584 0.680811C0.0373369 0.790365 0.0925825 0.890539 0.172924 0.968513L4.20453 5.00013L0.172924 9.03174C0.118945 9.08357 0.0758494 9.14564 0.0461615 9.21433C0.0164736 9.28302 0.000789937 9.35695 2.90789e-05 9.43178C-0.000731779 9.5066 0.0134455 9.58083 0.0417305 9.65011C0.0700155 9.71939 0.11184 9.78233 0.164754 9.83525C0.217668 9.88816 0.280608 9.92999 0.349888 9.95827C0.419168 9.98656 0.493396 10.0007 0.568224 9.99997C0.643051 9.99921 0.716975 9.98353 0.785666 9.95384C0.854357 9.92415 0.916433 9.88105 0.96826 9.82708L4.99987 5.79546L9.03148 9.82708C9.0833 9.88105 9.14538 9.92415 9.21407 9.95384C9.28276 9.98353 9.35669 9.99921 9.43151 9.99997C9.50634 10.0007 9.58057 9.98656 9.64985 9.95827C9.71913 9.92999 9.78207 9.88816 9.83499 9.83525C9.8879 9.78233 9.92972 9.71939 9.95801 9.65011C9.98629 9.58083 10.0005 9.5066 9.99971 9.43178C9.99895 9.35695 9.98326 9.28302 9.95358 9.21433C9.92389 9.14564 9.88079 9.08357 9.82681 9.03174L5.79521 5.00013L9.82681 0.968513C9.90866 0.890033 9.96487 0.78865 9.98809 0.677661C10.0113 0.566671 10.0004 0.451256 9.9569 0.346554C9.91337 0.241852 9.83921 0.15275 9.74415 0.0909352C9.64909 0.02912 9.53756 -0.00252267 9.4242 0.000157177Z" fill="#092957" />
                                                    </svg>
                                                </button>
                                            </div>
                                            :
                                            <button className="p-2 border-[0.752px] border-[#383e4724] rounded-[4px] opacity-90" onClick={() => {
                                                setTempVendorFee(vendorFee);
                                                setEditable(!editable);
                                            }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                    <g clip-path="url(#clip0_977_9026)">
                                                        <path d="M2.04142 13.9974H10.7914C11.3337 13.9959 11.8533 13.7792 12.2361 13.395C12.6188 13.0108 12.8336 12.4905 12.8331 11.9481V7.55156C12.8331 7.39685 12.7716 7.24848 12.6622 7.13908C12.5528 7.02969 12.4045 6.96823 12.2498 6.96823C12.095 6.96823 11.9467 7.02969 11.8373 7.13908C11.7279 7.24848 11.6664 7.39685 11.6664 7.55156V11.9481C11.6672 12.1811 11.5755 12.4049 11.4115 12.5704C11.2474 12.7359 11.0244 12.8295 10.7914 12.8307H2.04142C1.80842 12.8295 1.58543 12.7359 1.42139 12.5704C1.25734 12.4049 1.16565 12.1811 1.16642 11.9481V3.21331C1.16565 2.98031 1.25734 2.75652 1.42139 2.59105C1.58543 2.42559 1.80842 2.33196 2.04142 2.33073H6.41642C6.57113 2.33073 6.71951 2.26927 6.8289 2.15987C6.9383 2.05048 6.99976 1.90211 6.99976 1.7474C6.99976 1.59269 6.9383 1.44431 6.8289 1.33492C6.71951 1.22552 6.57113 1.16406 6.41642 1.16406H2.04142C1.4991 1.16561 0.979544 1.38225 0.596773 1.76644C0.214003 2.15063 -0.00070911 2.67099 -0.000243385 3.21331V11.9481C-0.00070911 12.4905 0.214003 13.0108 0.596773 13.395C0.979544 13.7792 1.4991 13.9959 2.04142 13.9974Z" fill="#092957" fill-opacity="0.4" />
                                                        <path d="M5.51488 6.15174L5.05463 8.25991C5.0338 8.35553 5.03736 8.45486 5.06498 8.54874C5.09261 8.64263 5.14341 8.72806 5.21271 8.79716C5.28297 8.86452 5.36843 8.91395 5.46185 8.94127C5.55527 8.96859 5.6539 8.97298 5.74938 8.95407L7.85288 8.49266C7.9621 8.46867 8.06213 8.4138 8.14105 8.33457L13.4575 3.01807C13.6201 2.85557 13.749 2.66263 13.837 2.4503C13.9249 2.23796 13.9702 2.01037 13.9702 1.78053C13.9702 1.55069 13.9249 1.32311 13.837 1.11077C13.749 0.898428 13.6201 0.705496 13.4575 0.54299C13.1243 0.224569 12.6812 0.046875 12.2203 0.046875C11.7594 0.046875 11.3163 0.224569 10.983 0.54299L5.67471 5.86474C5.59504 5.94312 5.53956 6.04274 5.51488 6.15174ZM11.8079 1.36841C11.9189 1.26209 12.0666 1.20274 12.2203 1.20274C12.374 1.20274 12.5217 1.26209 12.6327 1.36841C12.7406 1.47844 12.8011 1.62641 12.8011 1.78053C12.8011 1.93465 12.7406 2.08262 12.6327 2.19266L12.2203 2.60507L11.3955 1.78024L11.8079 1.36841ZM6.61621 6.56824L10.5677 2.60682L11.3844 3.42757L7.43113 7.39016L6.38405 7.61999L6.61621 6.56824Z" fill="#092957" fill-opacity="0.4" />
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_977_9026">
                                                            <rect width="14" height="14" fill="white" />
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                            </button>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        : null
                }

                {/* Currency Table */}
                <div className="border border-none border-table-border rounded-lg overflow-hidden">
                    <table className="w-full">
                        <thead>
                            <tr className="bg-[#F8F8F8]">
                                <th className="text-left p-[10px] text-sm font-semibold text-[#06224B]">Currency</th>
                                <th className="text-left p-[10px] text-sm font-semibold text-[#06224B]">Card Rate</th>
                                <th className="text-left p-[10px] text-sm font-semibold text-[#06224B]">Bank Rate</th>
                                <th className="text-left p-[10px] text-sm font-semibold text-[#06224B]">Default margin</th>
                                <th className="text-left p-[10px] text-sm font-semibold text-[#06224B]">Vendor Margin</th>
                                <th className="text-left p-[10px] text-sm font-semibold text-[#06224B]">K2 Rate</th>
                            </tr>
                        </thead>
                        <tbody>
                            {customers.slice(0, 10).map((row, index) => {
                                const isEditable = editingCurrency === row.currency;
                                const vendorMargin =
                                    purposeCode.label === "AD II"
                                        ? row.vendorMarginValue
                                        : purposeCode.label === "Gift"
                                            ? row.vendorMarginValueGift
                                            : row.vendorMarginValueMaintenance;
                                const defaultMargin =
                                    purposeCode.label === "AD II"
                                        ? row.marginValue
                                        : purposeCode.label === "Gift"
                                            ? row.marginValueGift
                                            : row.marginValueMaintanence
                                return (
                                    <tr key={row.currency} className={`hover:bg-[#F0F5FF] ${index !== customers.length - 1 ? "border-b border-border" : ""} ${isEditable ? "bg-[#F0F5FF]" : "bg-transparent"}`}>
                                        <td className="p-[10px] text-sm text-foreground">{row.currency}</td>
                                        <td className="p-[10px] text-sm text-muted-foreground">{purposeCodeSend == "other" ? row.cardRate : row.cardRateAd1}</td>
                                        <td className="p-[10px] text-sm text-muted-foreground">{row.rate}</td>
                                        <td className="p-[10px] text-sm text-muted-foreground">{!isUndefined(defaultMargin) ? defaultMargin : "N/A"}
                                        </td>
                                        <td className="p-[10px]">
                                            <div className="flex items-center gap-2">
                                                {isEditable ? (
                                                    <input
                                                        type="text"
                                                        // step="0.0001"
                                                        className="w-[60px] px-2 py-1 text-sm border-t-0 border-r-0 border-l-0 border-b focus:outline-none"
                                                        value={
                                                            editedVendorMargin?.[row.currency]?.[purposeCode?.label] ??
                                                            (purposeCode.label === "AD II"
                                                                ? row.vendorMarginValue
                                                                : purposeCode.label === "Gift"
                                                                    ? row.vendorMarginValueGift
                                                                    : row.vendorMarginValueMaintenance)
                                                        }
                                                        onChange={(e) => {
                                                            const sanitizedValue = sanitizeNumberInput(e.target.value);

                                                            setEditedVendorMargin((prev: any) => ({
                                                                ...prev,
                                                                [row.currency]: {
                                                                    ...prev?.[row.currency],
                                                                    [purposeCode.label]: sanitizedValue,
                                                                },
                                                            }));
                                                        }}
                                                    />
                                                ) : (
                                                    <span className="text-sm w-[60px] text-muted-foreground">
                                                        {!isUndefined(vendorMargin) ? updatingMargin ? <Skeleton /> : vendorMargin : "N/A"}
                                                    </span>
                                                )}
                                                {!isUndefined(vendorMargin) ?
                                                    isEditable ?
                                                        <div className="flex items-center gap-2">
                                                            <button className="p-2 border-[0.752px] border-[#383e4724] rounded-[4px] opacity-90" onClick={() => {
                                                                handleUpdateMargin(row);
                                                                setEditingCurrency(null);
                                                            }}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" viewBox="0 0 14 10" fill="none">
                                                                    <path d="M0.75 5.19444L4.44231 8.75L12.75 0.75" stroke="#092957" stroke-width="1.5" stroke-linecap="round" />
                                                                </svg>
                                                            </button>

                                                            <button className="p-2 border-[0.752px] border-[#383e4724] rounded-[4px] opacity-90" onClick={() => {
                                                                setEditedVendorMargin((prev: any) => {
                                                                    const copy = { ...prev };

                                                                    if (copy[row.currency]) {
                                                                        delete copy[row.currency][purposeCode.label];

                                                                        // clean empty currency object
                                                                        if (Object.keys(copy[row.currency]).length === 0) {
                                                                            delete copy[row.currency];
                                                                        }
                                                                    }

                                                                    return copy;
                                                                });

                                                                setEditingCurrency(null);
                                                            }}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                                                                    <path d="M9.4242 0.000157177C9.27557 0.00366517 9.13438 0.0658704 9.03148 0.173176L4.99987 4.20479L0.96826 0.173176C0.915828 0.119131 0.853077 0.0761632 0.78373 0.0468202C0.714383 0.0174773 0.63985 0.00235652 0.56455 0.00235424C0.452592 0.00238046 0.343188 0.0358156 0.250343 0.0983802C0.157497 0.160945 0.0854337 0.249792 0.043376 0.353551C0.00131824 0.457309 -0.00882019 0.571257 0.0142584 0.680811C0.0373369 0.790365 0.0925825 0.890539 0.172924 0.968513L4.20453 5.00013L0.172924 9.03174C0.118945 9.08357 0.0758494 9.14564 0.0461615 9.21433C0.0164736 9.28302 0.000789937 9.35695 2.90789e-05 9.43178C-0.000731779 9.5066 0.0134455 9.58083 0.0417305 9.65011C0.0700155 9.71939 0.11184 9.78233 0.164754 9.83525C0.217668 9.88816 0.280608 9.92999 0.349888 9.95827C0.419168 9.98656 0.493396 10.0007 0.568224 9.99997C0.643051 9.99921 0.716975 9.98353 0.785666 9.95384C0.854357 9.92415 0.916433 9.88105 0.96826 9.82708L4.99987 5.79546L9.03148 9.82708C9.0833 9.88105 9.14538 9.92415 9.21407 9.95384C9.28276 9.98353 9.35669 9.99921 9.43151 9.99997C9.50634 10.0007 9.58057 9.98656 9.64985 9.95827C9.71913 9.92999 9.78207 9.88816 9.83499 9.83525C9.8879 9.78233 9.92972 9.71939 9.95801 9.65011C9.98629 9.58083 10.0005 9.5066 9.99971 9.43178C9.99895 9.35695 9.98326 9.28302 9.95358 9.21433C9.92389 9.14564 9.88079 9.08357 9.82681 9.03174L5.79521 5.00013L9.82681 0.968513C9.90866 0.890033 9.96487 0.78865 9.98809 0.677661C10.0113 0.566671 10.0004 0.451256 9.9569 0.346554C9.91337 0.241852 9.83921 0.15275 9.74415 0.0909352C9.64909 0.02912 9.53756 -0.00252267 9.4242 0.000157177Z" fill="#092957" />
                                                                </svg>
                                                            </button>
                                                        </div>
                                                        :
                                                        <button className="p-2 border-[0.752px] border-[#383e4724] rounded-[4px] opacity-90" onClick={() => setEditingCurrency(row.currency)}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                <g clip-path="url(#clip0_977_9026)">
                                                                    <path d="M2.04142 13.9974H10.7914C11.3337 13.9959 11.8533 13.7792 12.2361 13.395C12.6188 13.0108 12.8336 12.4905 12.8331 11.9481V7.55156C12.8331 7.39685 12.7716 7.24848 12.6622 7.13908C12.5528 7.02969 12.4045 6.96823 12.2498 6.96823C12.095 6.96823 11.9467 7.02969 11.8373 7.13908C11.7279 7.24848 11.6664 7.39685 11.6664 7.55156V11.9481C11.6672 12.1811 11.5755 12.4049 11.4115 12.5704C11.2474 12.7359 11.0244 12.8295 10.7914 12.8307H2.04142C1.80842 12.8295 1.58543 12.7359 1.42139 12.5704C1.25734 12.4049 1.16565 12.1811 1.16642 11.9481V3.21331C1.16565 2.98031 1.25734 2.75652 1.42139 2.59105C1.58543 2.42559 1.80842 2.33196 2.04142 2.33073H6.41642C6.57113 2.33073 6.71951 2.26927 6.8289 2.15987C6.9383 2.05048 6.99976 1.90211 6.99976 1.7474C6.99976 1.59269 6.9383 1.44431 6.8289 1.33492C6.71951 1.22552 6.57113 1.16406 6.41642 1.16406H2.04142C1.4991 1.16561 0.979544 1.38225 0.596773 1.76644C0.214003 2.15063 -0.00070911 2.67099 -0.000243385 3.21331V11.9481C-0.00070911 12.4905 0.214003 13.0108 0.596773 13.395C0.979544 13.7792 1.4991 13.9959 2.04142 13.9974Z" fill="#092957" fill-opacity="0.4" />
                                                                    <path d="M5.51488 6.15174L5.05463 8.25991C5.0338 8.35553 5.03736 8.45486 5.06498 8.54874C5.09261 8.64263 5.14341 8.72806 5.21271 8.79716C5.28297 8.86452 5.36843 8.91395 5.46185 8.94127C5.55527 8.96859 5.6539 8.97298 5.74938 8.95407L7.85288 8.49266C7.9621 8.46867 8.06213 8.4138 8.14105 8.33457L13.4575 3.01807C13.6201 2.85557 13.749 2.66263 13.837 2.4503C13.9249 2.23796 13.9702 2.01037 13.9702 1.78053C13.9702 1.55069 13.9249 1.32311 13.837 1.11077C13.749 0.898428 13.6201 0.705496 13.4575 0.54299C13.1243 0.224569 12.6812 0.046875 12.2203 0.046875C11.7594 0.046875 11.3163 0.224569 10.983 0.54299L5.67471 5.86474C5.59504 5.94312 5.53956 6.04274 5.51488 6.15174ZM11.8079 1.36841C11.9189 1.26209 12.0666 1.20274 12.2203 1.20274C12.374 1.20274 12.5217 1.26209 12.6327 1.36841C12.7406 1.47844 12.8011 1.62641 12.8011 1.78053C12.8011 1.93465 12.7406 2.08262 12.6327 2.19266L12.2203 2.60507L11.3955 1.78024L11.8079 1.36841ZM6.61621 6.56824L10.5677 2.60682L11.3844 3.42757L7.43113 7.39016L6.38405 7.61999L6.61621 6.56824Z" fill="#092957" fill-opacity="0.4" />
                                                                </g>
                                                                <defs>
                                                                    <clipPath id="clip0_977_9026">
                                                                        <rect width="14" height="14" fill="white" />
                                                                    </clipPath>
                                                                </defs>
                                                            </svg>
                                                        </button>
                                                    : null
                                                }
                                            </div>
                                        </td>
                                        <td className="p-[10px] text-sm text-foreground font-medium">
                                            {(() => {
                                                const toNumber = (val: any, fallback = 0) => {
                                                    const num = Number(val);
                                                    return Number.isFinite(num) ? num : fallback;
                                                };

                                                const marginValue =
                                                    purposeCode.value === "marginValue"
                                                        ? row.marginValue
                                                        : purposeCode.value === "marginValueGift"
                                                            ? row.marginValueGift
                                                            : row.marginValueMaintanence;

                                                const vendorMarginValue =
                                                    purposeCode.value === "marginValue"
                                                        ? row.vendorMarginValue
                                                        : purposeCode.value === "marginValueGift"
                                                            ? row.vendorMarginValueGift
                                                            : row.vendorMarginValueMaintenance;

                                                const total = (
                                                    toNumber(row.rate) +
                                                    toNumber(marginValue) +
                                                    toNumber(vendorMarginValue)
                                                ).toFixed(4);

                                                return total;
                                            })()}

                                        </td>
                                    </tr>
                                );
                            }
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default MarginNew;